
const ShowExample = ({ onConfirmExample }) => (
  <div class="define-data-card">
    <h2 class="h2">Show an example</h2>
    <p>
      This generates a wind rose with predefined directions and bins with random
      data just to give you an idea of how it all works.
    </p>
    <div class="flex justify-end pt-2">
      <button class="btn btn-blue my-4" onClick={onConfirmExample}>
        OK, show example
      </button>
    </div>
  </div>
);

export { ShowExample };
